import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClient, CreateSaleRequest, SaleInfo } from '../sdk/sdk';

@Injectable({
  providedIn: 'root'
})
export class SalesService {
  private readonly apiClient = inject(ApiClient);

  createSale(request: CreateSaleRequest): Observable<SaleInfo> {
    return this.apiClient.createSale(request);
  }
}

